import initializeSwiperCarousel from "./swiper-carousel";
import initSwiperCarousels from "./swiperCarouselBasic";

const initializeExperienceComponents = () => {
    initializeSwiperCarousel();
    initSwiperCarousels();
};

export default initializeExperienceComponents;
